import css from 'styled-jsx/css';
import typography from '../../../styles/typography';

export const styles = css`
  .Category__underTitleContainer {
    margin-bottom: 25px;
    display: flex;
    justify-content: flex-end;
    align-items: center;
  }

  .Category__goodsNumber {
    ${typography.text}
    color: var(--colors-doveGray);
    margin-right: auto;
  }

  .Category__lastVisitedSlider {
    margin-top: 60px;
  }
`;
